// <auto-generated /> by equerra-portal-module-registry, from this app's own package.json (S48-D4).
// Do not edit. Adding a module is a dependency line and this file follows from it, and CI regenerates it
// and requires no diff, in the same step that regenerates the API client from the committed contract.

import { assertPortalModuleSlug } from '@equerranz/portal-module-contract';
import type { PortalModuleManifest } from '@equerranz/portal-module-contract';
import coaModule from '@equerranz/portal-module-coa';

/** Every module this portal carries. Its dependency set, and nothing else (D13). */
export const portalModules: readonly PortalModuleManifest[] = [
  assertPortalModuleSlug('@equerranz/portal-module-coa', coaModule),
];
